import React, { useState } from "react";
import axiosInstance from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/api/apiConfig";
import { useNavigate } from "react-router-dom";
import PatientFormBase from "./PatientFormBase";
import ResponseMessage from "../common/ResponseMessage";

const PatientAccountRegistration: React.FC = () => {
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data: import("../../types").PatientFormData) => {
    setIsSubmitting(true);
    setResponseMessage("");
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("No token found");
      await axiosInstance.post(API_ENDPOINTS.USERS.CREATE, data);
      setResponseMessage("Compte patient créé avec succès !");
      setTimeout(() => navigate("/admin/dashboard/account/patient"), 1500);
    } catch (err) {
      setResponseMessage("Erreur lors de la création du compte patient.");
      console.error("Error creating patient:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-4">
      <PatientFormBase
        mode="create"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      {responseMessage && (
        <ResponseMessage message={responseMessage} role="admin" />
      )}
    </div>
  );
};

export default PatientAccountRegistration;
